import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { ModalContainer, ModalPortal } from "@xo-union/ui-accessibility";
import noop from "lodash/noop";
import cx from "classnames";
import Overlay from "@xo-union/tk-component-overlay";
import styles from "../../css/index.css";

const RightRail = _ref => {
  let {
    visible,
    className,
    overlay,
    onOverlayClick,
    onEscapeKey,
    onClose,
    width,
    style,
    children,
    ...props
  } = _ref;
  const right = visible ? 0 : `-${width}`;
  const appliedStyles = {
    width,
    right,
    ...style
  };
  return /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(Overlay, {
    color: "dark",
    enabled: visible,
    visible: overlay
  }, /*#__PURE__*/React.createElement(ModalContainer, _extends({
    className: cx(styles['right-rail'], className),
    style: appliedStyles,
    onClose: onClose,
    onClickOutside: onOverlayClick,
    onEscapeKey: onEscapeKey,
    enabled: visible
  }, props), children)));
};

process.env.NODE_ENV !== "production" ? RightRail.propTypes = {
  /**
   * Contents of the Right Rail
   */
  children: PropTypes.node,

  /**
   * Additional classNames the consumer can pass
   */
  className: PropTypes.string,

  /**
   * Whether or not to show an overlay when the RightRail is in view.
   */
  overlay: PropTypes.bool,

  /**
   * Additional style properties to be applied
   */
  style: PropTypes.shape(),

  /**
   * Whether or not the RightRail is in view.
   */
  visible: PropTypes.bool,

  /**
   * How wide the RightRail is.
   */
  width: PropTypes.string,

  /**
   * Function for when the overlay is clicked on or ESC key is pressed
   */
  onOverlayClick: PropTypes.func,

  /**
   * Function for when the overlay is clicked on or ESC key is pressed
   */
  onClose: PropTypes.func,

  /**
   * Function for when ESC key is pressed
   */
  onEscapeKey: PropTypes.func
} : void 0;
RightRail.defaultProps = {
  visible: false,
  width: '536px',
  style: {},
  overlay: false,
  onClose: noop,
  onOverlayClick: noop,
  onEscapeKey: noop
};
export default RightRail;